var path = 'src/app/forms/fields/radio-field.html';
var html = "<label class=radio ng-repeat=\"option in data.options\"> <input frm-model frm-required type=radio ng-model=data.model ng-value=option.id ng-required=required() /> {{option.label}} </label> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/forms/fields/radio-field.html
 ** module id = 288
 ** module chunks = 0
 **/